import { Box, Typography } from "@mui/material";

export function PaymentTermCardTooltip({
  monthlyPaymentPlanStates,
}: {
  monthlyPaymentPlanStates: string;
}) {
  return (
    <>
      <Typography variant="body2">
        Monthly payment plan is available if all the following apply:
      </Typography>
      <Box component="ul" sx={{ pl: 4, my: 0 }}>
        <Box component="li">
          <Typography variant="body2">
            AOP deductible is $1,000 or more
          </Typography>
        </Box>
        <Box component="li">
          <Typography variant="body2">
            Annualized premium is $500 or more
          </Typography>
        </Box>
        <Box component="li">
          <Typography variant="body2">
            Wind/Hail deductible is $2,500 or more (if applicable)
          </Typography>
        </Box>
        <Box component="li">
          <Typography variant="body2">Credit Card/ACH payment only</Typography>
        </Box>
      </Box>
      <Typography variant="body2">
        Available in: {monthlyPaymentPlanStates}.
      </Typography>
    </>
  );
}
